import React from 'react';
import {
    Spinner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../common/Helpers';
import AutoTagProductByTypeComponent from './AutoTagProductByTypeComponent';

class AutoTagProductByTypePage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            rule: null,
            editId: null
        };

        const { params } = this.props.match;

        if (params.id) {
            this.state.editId = params.id
        }
    }

    render() {

        var title = "Create Product Type Rule";
        var actionTitle = "Create";

        if (this.state.editId != null) {
            title = "Update Product Type Rule";
            actionTitle = "Update";
        }

        return (
            <React.Fragment>
                {this.state.loading && <Spinner accessibilityLabel="Loading" size="large" color="teal" />}
                {!this.state.loading && <AutoTagProductByTypeComponent
                    title={title}
                    actionTitle={actionTitle}
                    rule={this.state.rule}
                    onAction={this.handleSaveOrCreate}
                />}
            </React.Fragment>
        );
    }

    handleSaveOrCreate = (rule) => {

        let body = JSON.stringify({ ...rule });
        let method = "POST";

        if (this.state.editId != null) {
            method = "PUT";
            body = JSON.stringify({
                ...rule,
                id: this.state.editId
            });
        }

        fetch(`api/tagRules/AutoTagProductByType`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: body
        }).then(() => {
            this.props.history.push("/tag-rules");
        });
    }

    componentDidMount() {

        if (this.state.editId != null) {
            fetch(`api/tagRules/AutoTagProductByType/${this.state.editId}`, {
                method: 'get'
            })
                .then(response => response.json())
                .then(data => this.setState({
                    rule: data,
                    loading: false
                }));
        }
        else {
            this.setState({
                loading: false
            })
        }
    }
}

export default AutoTagProductByTypePage;